export const CONTACTS = [
	{
		type: 'tel',
		href: '+998910104579',
		title: '+998 91 010 4579',
		ymId: 'tel',
	},
	{
		type: 'email',
		href: 'marketing.uz@veon.com',
		title: 'marketing.uz@veon.com',
		ymId: 'email',
	},
]

export const SOCIALS = [
	{
		type: 'linkedin',
		href: 'http://linkedin.com/company/veon-adtech',
		title: 'LinkedIn',
		ymId: 'follow_linkedin',
	},
	{
		type: 'telegram',
		href: 'https://t.me/VeonAdTech',
		title: 'Telegram',
		ymId: 'follow_telegram',
	},
	{
		type: 'instagram',
		href: 'https://www.instagram.com/veon.adtech?igsh=MWgwM216djR1OGd3dg==',
		title: 'Instagram',
		ymId: 'follow_instagram',
	},
	{
		type: 'facebook',
		href: 'https://www.facebook.com/VEONAdTech.Solutions',
		title: 'Facebook',
		ymId: 'follow_facebook',
	},
	{
		type: 'twitter',
		href: 'https://x.com/VEON_AdTech',
		title: 'Twitter',
		ymId: 'follow_twitter',
	},
]
